import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { HomeResponse } from 'api/home';
import { FetchStatus } from 'data/core';
import { saveNormalizedPartialTasks } from 'data/tasks/slice';
import { logger } from 'services';
import { saveHomeResponseSagaAction } from '../actions';
import { homeNormalizer } from '../schema';
import { saveHomeResponse, fetchHomeResponseError } from '../slice';

function* saveHomeResponseSaga({
  payload,
}: PayloadAction<HomeResponse>): Generator {
  const response = payload;

  try {
    const normalizedResponse = homeNormalizer(response);
    const {
      entities: { tasks },
    } = normalizedResponse;

    yield put(saveNormalizedPartialTasks(tasks));

    yield put(
      saveHomeResponse({
        data: normalizedResponse,
        fetchStatus: FetchStatus.Loaded,
      }),
    );
  } catch (error) {
    logger.error('Unable to store home tasks', { error });
    yield put(fetchHomeResponseError());
  }
}

export const watchSaveHomeResponseSaga = function* (): Generator {
  yield takeLatest(saveHomeResponseSagaAction.type, saveHomeResponseSaga);
};
